/* eslint-disable no-param-reassign */
import produce from 'immer';
import {
  GET_TEXTING_OPT_IN_DATA,
  GET_TEXTING_OPT_IN_DATA_SUCCESS,
  GET_TEXTING_OPT_IN_DATA_ERROR,
  SUBMIT_TEXTING_OPT_IN,
  SUBMIT_TEXTING_OPT_IN_SUCCESS,
  SUBMIT_TEXTING_OPT_IN_ERROR,
} from 'src/actions/textingOptInActions';

const optInData = {
  loading: false,
  data: {
    firstName: '',
    lastName: '',
    mobilePhone: '',
    demo: false,
  },
};

const initialState = {
  formOptInDataloading: false,
  optInData,
  message: {},
};

const textingOptInReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_TEXTING_OPT_IN_DATA: {
      return produce(state, (draft) => {
        draft.optInData.loading = true;
      });
    }

    case GET_TEXTING_OPT_IN_DATA_SUCCESS: {
      return produce(state, (draft) => {
        draft.optInData.data = payload || {};
        draft.optInData.loading = false;
      });
    }

    case GET_TEXTING_OPT_IN_DATA_ERROR: {
      return produce(state, (draft) => {
        draft.optInData.loading = false;
      });
    }

    case SUBMIT_TEXTING_OPT_IN: {
      return produce(state, (draft) => {
        draft.formOptInDataloading = true;
      });
    }

    case SUBMIT_TEXTING_OPT_IN_SUCCESS: {
      return produce(state, (draft) => {
        draft.message = payload || {};
        draft.formOptInDataloading = false;
      });
    }

    case SUBMIT_TEXTING_OPT_IN_ERROR: {
      return produce(state, (draft) => {
        draft.formOptInDataloading = false;
      });
    }

    default: {
      return state;
    }
  }
};

export default textingOptInReducer;
